import {lazy} from 'react';

import {Route, Routes, Navigate, useLocation} from 'react-router-dom';

const HomeLayout = lazy(() => import('../pages/plugin/Home'));

const BookingPages = lazy(() => import('../pages/plugin/Home/BookingPages'));
const Events = lazy(() => import('../pages/plugin/Home/Events'));

const Purchase = lazy(() => import('../pages/plugin/Purchase'));

const MobileRoutes = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <Routes>
      <Route exact path="/" element={<Navigate to={`/m/home/booking-pages?${params.toString()}`} />} />
      <Route path="/home" element={<HomeLayout />}>
        <Route index element={<Navigate to={`/m/home/booking-pages?${params.toString()}`} />} />
        <Route path="booking-pages" element={<BookingPages />} />
        <Route path="events" element={<Events />} />
      </Route>
      <Route path="/purchase" element={<Purchase />}></Route>
    </Routes>
  );
};

export default MobileRoutes;
